import React, { Component } from 'react'
import { Text, View, StyleSheet, TouchableOpacity } from 'react-native'
import Theme from '../../theme'
import Icon from '../../components/Icon';

class MusicPlatformsPlaylistOptions extends Component {

    render() {
        const { openPlatform, openRecommendedPlaylist } = this.props;
        return (
            <View>
                <View style={styles.bodyGroupPlaylistButtonsContainer}>
                    <View style={styles.horizontalSeparator} />
                    <TouchableOpacity onPress={openRecommendedPlaylist} style={styles.bodyGroupPlaylistButton}>
                        <View style={styles.iconTitleContainer}>
                            <Icon
                                style={{ color: Theme.BLACK, paddingHorizontal: 5 }}
                                size={30}
                                name={'ios-star-outline'}
                            />
                            <Text style={styles.bodyGroupTitle}>recommended</Text>
                        </View>
                        <TouchableOpacity onPress={openRecommendedPlaylist}>
                            <Icon
                                style={styles.playIcon}
                                size={20}
                                name={'md-play'}
                            />
                        </TouchableOpacity>
                    </TouchableOpacity>
                    <View style={styles.horizontalSeparator} />

                    <TouchableOpacity onPress={openPlatform} style={styles.bodyGroupPlaylistButton}>
                        <View style={styles.iconTitleContainer}>
                            <Icon
                                style={{ color: Theme.BLACK, paddingHorizontal: 5 }}
                                size={42}
                                name={'ios-person-outline'}
                            />
                            <Text style={styles.bodyGroupTitle}>your playlist</Text>
                        </View>
                        <TouchableOpacity onPress={openPlatform}>
                            <Icon
                                style={styles.playIcon}
                                size={20}
                                name={'md-play'}
                            />
                        </TouchableOpacity>
                    </TouchableOpacity>
                </View>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    bodyGroupPlaylistButtonsContainer: {
        flexDirection: 'column',
        justifyContent: 'space-around',
        marginHorizontal: 10,
    },
    bodyGroupPlaylistButton: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    playIcon: {
        color: Theme.BLACK,
        width: 45,
    },
    horizontalSeparator: {
        borderBottomWidth: 1,
        marginVertical: 10,
        borderBottomColor: Theme.GREY_LIGHT,
    },
    iconTitleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    bodyGroupTitle: {
        paddingHorizontal: 10,
    }
})

export default MusicPlatformsPlaylistOptions;
